import React from 'react';
import { Modal, Box, Typography, IconButton, Avatar, Link } from '@mui/material';
import { Close, Edit, Delete } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import OverflowTooltip from '../../../shared/OverflowTooltip';
import './NotesModal.scss';

const NotesModal = ({ open, onClose, notes, date, onEdit, onDelete }) => {
  const { t } = useTranslation();
  return (
    <Modal open={open} onClose={onClose}>
      <Box className="notes-modal">
        <Box className="notes-modal-header">
          <Typography className="notes-modal-date">{date}</Typography>
          <IconButton onClick={onClose} size="small">
            <Close />
          </IconButton>
        </Box>
        
        <Box className="notes-modal-content">
          {notes.map((note, index) => (
            <React.Fragment key={note.id}>
              <Box className="note-item">
                <Box className="note-text-container">
                  <Typography className="note-text">
                    <strong>{t('calendar.note')}</strong> {note.text}
                  </Typography>
                  <Box className="note-actions">
                    <IconButton 
                      size="small" 
                      onClick={() => onEdit(note)}
                      className="note-action-icon"
                    >
                      <Edit sx={{ fontSize: 18 }} />
                    </IconButton>
                    <IconButton 
                      size="small" 
                      onClick={() => onDelete(note)}
                      className="note-action-icon"
                    >
                      <Delete sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Box>
                </Box>
                
                {(note.assignee || note.linkedTicket || note.createdAt) && (
                  <Box className="note-details">
                    {note.linkedTicket && note.linkedTicket.title && (
                      <Box>
                        <Typography className="note-detail-text" component="div">
                          <strong>{t('calendar.linkedTicket')}</strong>{' '}
                          {note.linkedTicket.ticket_number && (
                            <>
                              <Link 
                                href={`/task/${note.linkedTicket.ticket_number}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="note-ticket-link"
                                onClick={(e) => e.stopPropagation()}
                              >
                                {note.linkedTicket.ticket_number}
                              </Link>
                              {' - '}
                            </>
                          )}
                          {note.linkedTicket.title}
                        </Typography>
                      </Box>
                    )}
                    <Box className="note-bottom-row">
                      {note.createdAt && (
                        <Typography className="note-detail-text">
                          <strong>{t('calendar.createdAt')}</strong> {note.createdAt}
                        </Typography>
                      )}
                      {note.assignee && note.assignee.name && (
                        <Box className="note-assignee-row">
                          <Avatar sx={{ width: 20, height: 20, fontSize: 11 }}>
                            {note.assignee.name.charAt(0)}
                          </Avatar>
                          <OverflowTooltip title={note.assignee.name} sx={{ flex: 1 }} component={Typography} className="note-assignee-name">
                            {note.assignee.name}
                          </OverflowTooltip>
                        </Box>
                      )}
                    </Box>
                  </Box>
                )}
              </Box>
              {index < notes.length - 1 && <Box className="note-divider" />}
            </React.Fragment>
          ))}
        </Box>
      </Box>
    </Modal>
  );
};

export default NotesModal;
